<template>
  <div class="attendance-tabs">
    <div class="attendance-tabs__row">
      <div
        v-for="item in tabs"
        :key="item.key"
        :class="item.key === activeKey ? 'attendance-tabs__item active' : 'attendance-tabs__item'"
        @click="$emit('change', item)"
      >
        <span class="attendance-tabs__label">{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AttendanceTabs",
  props: {
    activeKey: {
      type: String,
      default: "record",
    },
    tabs: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.attendance-tabs {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.attendance-tabs__row {
  display: flex;
  align-items: center;
  overflow: hidden;
  border: 1px solid #63b3f4;
  border-radius: 18px;
}

.attendance-tabs__item {
  height: 34px;
  min-width: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 18px;
  box-sizing: border-box;
  cursor: pointer;
  transition: all ease 0.3s;
  color: #409eff;
  background: #fff;

  & + .attendance-tabs__item {
    border-left: 1px solid #63b3f4;
  }

  &.active {
    background: #1890ff;
  }

  &.active .attendance-tabs__label {
    color: #fff;
  }
}

.attendance-tabs__label {
  font-size: 12px;
  line-height: 1;
}
</style>
